<template>
  <div>
    <IngestRdrFileAction ref="ingestAction" />
    <AutoDetectFileAction ref="autodetectAction" />
    <v-menu v-model="menu" :close-on-content-click="false" offset-y :position-x="position.x" :position-y="position.y">
      <v-list dense>
        <v-list-tile :to="{ name: 'dataset', params: { id: file.Id }}">
          <v-list-tile-avatar>
            <v-icon>description</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>View details</v-list-tile-title>
        </v-list-tile>
        <v-list-tile :href="`/download/${ file.Id }`" :title="file.Name" @click.prevent="downloadFile()">
          <v-list-tile-avatar>
            <v-icon>save_alt</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>Download</v-list-tile-title>
        </v-list-tile>
        <v-divider class="my-2" />
        <!-- <v-list-tile v-if="viewIngestionResultsLink" :to="viewIngestionResultsLink">
          <v-list-tile-avatar>
            <v-icon>assignment</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>View import results</v-list-tile-title>
        </v-list-tile> -->
        <!-- <v-list-tile v-if="isTenantAdmin" @click="ingest(file.Id)">
          <v-list-tile-avatar>
            <v-icon>publish</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>
            {{ viewIngestionResultsLink ? 'Reingest data' : 'Ingest data' }}
          </v-list-tile-title>
        </v-list-tile> -->
        <v-list-tile v-if="reviewIngestionLink" :to="reviewIngestionLink">
          <v-list-tile-avatar>
            <v-icon>rule</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>Review file</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="isTenantAdmin" @click="autodetect(file.Id)">
          <v-list-tile-avatar>
            <v-icon>preview</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>Auto-detect file type</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
  import { download } from '@/helpers/download'
  import { getIngestionLink, getIngestionResultsLink } from '@/helpers/datasets/ingestions'
  import { createNamespacedHelpers } from 'vuex'

  const ingestions = createNamespacedHelpers('ingestions')
  const authenticate = createNamespacedHelpers('authenticate')

  export default {
    data: () => ({
      menu: false,
      file: {},
      position: {
        x: 0,
        y: 0,
      },
      resultsTitle: '',
    }),
    computed: {
      ...authenticate.mapGetters(['isTenantAdmin']),
      reviewIngestionLink() {
        let ingestionLink = getIngestionLink(this.file)
        return ingestionLink
      },
      viewIngestionResultsLink() {
        let ingestionResultsLink = getIngestionResultsLink(this.file)
        return ingestionResultsLink
      },
    },
    methods: {
      ...ingestions.mapActions(['ingestFiles']),
      show(file) {
        if (this.menu) return
        console.log('item', file)
        this.position = {
          x: event.clientX,
          y: event.clientY,
        }

        this.file = file
        this.menu = true
      },
      downloadFile() {
        let file = this.file
        file.loading = true

        let options = {
          successful: () => {
            file.loading = false
          },
          failedCb: (error) => {
            file.loading = false
            this.$store.dispatch('app/setSnackbar', {
              text: error,
              color: 'error',
              icon: 'error',
            })
          },
        }

        download(
          `api/RawDataRepository/file/${ file.Id }/download`,
          file.Name,
          options
        )
      },
      ingest(fileId) {
        this.$refs.ingestAction.submit(fileId)
      },
      autodetect(fileId) {
        this.$refs.autodetectAction.submit(fileId)
      },
    },
  }
</script>